import { useQuery } from '@tanstack/react-query';
import { STALE_TIME } from 'infrastructure/consts/stale-time';
import { rangeTypesDataSource } from 'infrastructure/data-sources/range-type';

import useApi from '../use-api';

import type {
  ISmsMetricsFilters,
  ISmsMetricSummaryData,
} from 'infrastructure/interfaces';

type MetricType = 'status' | 'type';

const api = (type: MetricType) => `core-2/sms-metrics/${type}-summary`;

const prepareFilters = (filters: ISmsMetricsFilters) => {
  const rangeType = rangeTypesDataSource().find(
    (el) => el.id === filters.rangeType,
  );
  const newFilters: any = structuredClone(filters);
  delete newFilters.rangeType;
  if (rangeType) {
    Object.assign(newFilters, { interval: rangeType.interval });
  }
  return newFilters;
};

export const useGetSmsSummaryMetrics = (
  filters: ISmsMetricsFilters,
  metricType: MetricType,
  enabled = true,
) => {
  const queryKey = [
    'useGetSmsSummaryMetricsByType',
    filters.startTime,
    filters.endTime,
    filters.smsType,
    filters.status,
    metricType,
  ] as const;

  const { loadData } = useApi();

  const {
    data = [],
    error,
    isLoading,
  } = useQuery<ISmsMetricSummaryData>({
    queryKey,
    staleTime: STALE_TIME,
    queryFn: async () => {
      const res = await loadData<ISmsMetricSummaryData>(
        api(metricType),
        prepareFilters(filters),
      );
      if (res) return res;
      return [];
    },
    enabled,
  });

  return {
    data,
    isLoading,
    error,
  };
};
